export enum PropertyTypeEnum {
  SingleFamilyHome = 'single_family',
  MultiFamilyHome = 'multi_family_home',
  Condo = 'condo',
  CoOp = 'coop',
}
